import api from '../api';
const baseUrl = process.env.REACT_APP_AUTH_API_URL;

const getUserByToken = async (keycloakToken) => {
    try {
        const response = await api.get(`${baseUrl}/users/me`, {
            headers: {
                'Authorization': `Bearer ${keycloakToken}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching user by id:", error);
        throw new Error(error?.response?.data?.message || "Erro ao buscar usuário.");
    }
}

export default { getUserByToken };